import { render } from "./Robotica.vue?vue&type=template&id=286a74ad&scoped=true&bindings={\"imgs\":\"setup\"}"
import script from "./Robotica.vue?vue&type=script&lang=js"
export * from "./Robotica.vue?vue&type=script&lang=js"

import "./Robotica.vue?vue&type=style&index=0&id=286a74ad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-286a74ad"

export default script